import { jsx as o } from "react/jsx-runtime";
import { ICONS_COLOR_MAPPING as i } from "./index.es2359.js";
import { ROTATE_CONVERSION as l } from "./index.es2374.js";
const n = ({
  outline: t = "default-gray",
  direction: C = "up"
}) => {
  const r = i[t], L = C !== "down" ? { transform: `rotate(${l[C]}deg)` } : {};
  return /* @__PURE__ */ o(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: L,
      children: /* @__PURE__ */ o(
        "path",
        {
          d: "M12.3536 7.35355C12.18 7.52712 11.9106 7.5464 11.7157 7.41141L11.6464 7.35355L8.501 4.207L8.5 13C8.5 13.2761 8.27614 13.5 8 13.5C7.75454 13.5 7.55039 13.3231 7.50806 13.0899L7.5 13L7.501 4.205L4.35355 7.35355C4.17999 7.52712 3.91056 7.5464 3.71569 7.41141L3.64645 7.35355C3.47288 7.17999 3.4536 6.91056 3.58859 6.71569L3.64645 6.64645L7.64645 2.64645L7.65871 2.63459C7.67118 2.62294 7.68425 2.61192 7.69786 2.60158L7.64645 2.64645C7.67328 2.61961 7.70241 2.59647 7.73319 2.57701C7.74432 2.57002 7.75595 2.56329 7.76787 2.55703C7.78172 2.54975 7.79546 2.54335 7.80941 2.53761C7.82198 2.53241 7.83526 2.52756 7.8488 2.52327C7.86417 2.51845 7.87953 2.5144 7.89501 2.51109C7.90499 2.5089 7.91532 2.50703 7.92576 2.50547C7.94709 2.50234 7.96827 2.50055 7.98946 2.50011C7.99251 2.50004 7.99625 2.5 8 2.5L8.01154 2.50013C8.0324 2.50061 8.05324 2.50239 8.07392 2.50546L8 2.5C8.0361 2.5 8.0713 2.50383 8.10523 2.51109C8.12047 2.5144 8.13583 2.51845 8.15101 2.52324C8.16474 2.52756 8.17803 2.53241 8.19104 2.53779C8.20454 2.54335 8.21828 2.54975 8.23176 2.5568C8.24405 2.56329 8.25568 2.57002 8.26701 2.57719C8.2727 2.58073 8.27854 2.58459 8.28431 2.58859L8.30214 2.60158C8.31575 2.61192 8.32882 2.62294 8.34129 2.63459L8.35355 2.64645L12.3536 6.64645C12.5488 6.84171 12.5488 7.15829 12.3536 7.35355Z",
          fill: r
        }
      )
    }
  );
};
n.__tags = ["arrow", "directional"];
export {
  n as UtilityDirectionalArrowIcon
};
//# sourceMappingURL=index.es437.js.map
